import React, { useCallback } from 'react';
import { prop } from 'ramda';
import { useIsAdmin } from 'js/hooks/user';
import { Portlet } from 'js/components/system/Portlet';
import { NavigationBar } from 'js/components/main/NavigationBar';
import { clsx } from 'js/utils/classNames.util';
import { useDeviceSelector, useUserSelector } from 'js/store/hooks';

import * as hooks from './hooks';
import { withPageEvent } from '../../hocs';

import style from './Layout.scss';

export const LayoutBare = ({ page, isLoading }) => {
    const isAdmin = useIsAdmin();
    const formFactor = useDeviceSelector(prop('formFactor'));
    const role = useUserSelector(prop('role'));
    const { portlets, pageLayout, friendlyURL } = page;
    const isNavigationBarAvailable = hooks.useIsNavigationBarAvailable(friendlyURL);

    const getLayout = useCallback((layoutItem, isNavigationBar) => {
        const layout = [];
        const rootLayoutClassName = isNavigationBar ? style.rootLayoutWithNavigation : '';

        if (layoutItem.children?.length) {
            layout.push(
                <div
                    id={layoutItem.id}
                    key={layoutItem.id}
                    style={isNavigationBar ? {} : { width: layoutItem.width }}
                    className={`${style[layoutItem.layoutType]} page-layout-${layoutItem.layoutType} ${rootLayoutClassName}`}
                >
                    {layoutItem.children.map(child => getLayout(child))}
                </div>
            );
        } else {
            layout.push(
                <div
                    id={layoutItem.id}
                    key={layoutItem.id}
                    data-column-id={`column-${layoutItem.dropZoneId}`}
                    style={isNavigationBar ? {} : { width: layoutItem.width }}
                    className={`${style.layout} ${layoutItem.customClasses} ${rootLayoutClassName}`}
                >
                    <div
                        id={`layout-column_column-${layoutItem.dropZoneId}`}
                        className={`portlet-dropzone portlet-column-content fn-portlet-container column-${layoutItem.dropZoneId}`}
                    >
                        {portlets
                            .filter(portlet => isAdmin
                                || Boolean(portlet.enabledDevices[formFactor]) && Boolean(portlet.permissions[role]))
                            .filter(portlet => portlet.column === `column-${layoutItem.dropZoneId}` || portlet.column === layoutItem.dropZoneId)
                            .map(portlet => <Portlet key={portlet.portletKey} portlet={portlet}/>)}
                    </div>
                </div>
            );
        }

        return layout;
    }, [formFactor, isAdmin, portlets, role]);

    return (
        <div
            id="main-content"
            style={pageLayout.layoutWidth ? { width: pageLayout.layoutWidth } : {}}
            className={clsx([
                'layout-wrapper',
                style.layoutWrapper,
                isAdmin ? style.admin : '',
                pageLayout.layoutClasses,
                isLoading ? style.loading : style.loaded
            ])}
        >
            {isNavigationBarAvailable() && <NavigationBar currentPageURL={friendlyURL} />}
            {getLayout(pageLayout.layouts[0], isNavigationBarAvailable())}
        </div>
    );
};

export const Layout = withPageEvent(LayoutBare);
